module.exports = __webpack_public_path__ + "img/ehr_main.6788fc20.png";